export function externalRegistrationCta(event) {
  const href = typeof event?.registrationUrl === 'string' ? event.registrationUrl.trim() : '';
  if (!href) return null;
  return {
    href,
    label: 'Register / RSVP',
    target: '_blank',
    rel: 'noopener noreferrer',
    supportingText: 'Registration is handled on an external website. MTS does not collect registrations or RSVPs.',
  };
}

export function publicEventLocation(event) {
  const text = value => typeof value === 'string' ? value.trim() : '';
  const name = text(event?.venueName) || text(event?.location);
  const address = text(event?.address);
  return name || address ? { name, address } : null;
}

export function publicEventTimeZone(event, tenantTimeZone) {
  const zone = event?.timezone || tenantTimeZone || 'UTC';
  try { new Intl.DateTimeFormat('en-US', { timeZone: zone }); return zone; } catch { return 'UTC'; }
}

export function eventSchemaDate(value, timeZone = 'UTC') {
  if (!value) return undefined;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  // Timed public API records carry an explicit offset. Never interpret a bare
  // local clock differently in the server's and visitor's timezones.
  if (typeof value === 'string' && !/(?:Z|[+-]\d{2}:\d{2})$/i.test(value)) return undefined;
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return undefined;
  try {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone, calendar: 'gregory', numberingSystem: 'latn', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23', timeZoneName: 'longOffset' }).formatToParts(date).map(part => [part.type, part.value]));
    const offset = parts.timeZoneName === 'GMT' ? 'Z' : parts.timeZoneName.replace('GMT', '');
    const milliseconds = date.getUTCMilliseconds() ? `.${String(date.getUTCMilliseconds()).padStart(3, '0')}` : '';
    return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}${milliseconds}${offset}`;
  } catch { return date.toISOString(); }
}
